import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
  alternateUser: [],
  alternateUserPagination: null,
});

const alternateUserSlice = createSlice({
  name: 'alternateUser',
  initialState,
  reducers: {
    setAlternateUser: (state, action) => {
      const { users, pagination } = action.payload;
      localStorage.setItem(`alternateUser`, JSON.stringify(users));
      localStorage.setItem(`alternateUserPagination`, JSON.stringify(pagination));
      state.alternateUser = users;
      state.alternateUserPagination = pagination;
    },
  },
});

export const { setAlternateUser } = alternateUserSlice.actions;

export default alternateUserSlice.reducer;
